import { Component, OnDestroy, OnInit } from '@angular/core';
import { ProjectService } from '../services/project.service';
import { Subscription } from 'rxjs';
import { AppComponent } from '../app.component';
import { closeSubscription, runTeardown } from '../services/safe-teardown';

@Component({
  selector: 'app-project',
  templateUrl: './project.component.html',
  styleUrls: ['./project.component.scss'],
})
export class ProjectComponent implements OnInit, OnDestroy {
  file: File | null = null;
  projectName: string = '';
  selectedProjectSubscription?: Subscription;

  constructor(
    public projectService: ProjectService,
    private appComponent: AppComponent
  ) {}

  ngOnInit(): void {
    this.projectService.isHelpOverlayVisible = false;
    this.selectedProjectSubscription =
      this.projectService.selectedProject.subscribe(
        (data) => {
          this.projectName = data;
        },
        (error) => console.log(error)
      );
  }

  /** Teardown must never abort a route deactivation — see safe-teardown.ts. */
  ngOnDestroy(): void {
    runTeardown('ProjectComponent.ngOnDestroy', () => {
      closeSubscription('selectedProjectSubscription', this.selectedProjectSubscription);
    });
  }

  onFileInput(): void {
    // REALTIME changes
    // this.appComponent.projectLoadPerc = 0;
    // this.appComponent.projUploading = true;
    // var fileName = 'REALTIME';
    // this.projectService.isMetricUnit =
    //   this.projectService.toUpload_isMetricUnit;
    // this.projectService.selectedLang =
    //   this.projectService.toUpload_selectedLang;
    // this.appComponent.projectLoadPerc = 100;
    // this.appComponent.projUploading = false;
    // this.appComponent.tempDataLoading = true;
    // this.projectService.setUploadedProject(fileName);
  }
}
